import { memo } from 'react';
import styled, { css } from 'styled-components';
import TopRow from '@/components/Menu/shared/TopRow';
import useLogoColorVariable from '@repo/ui/src/hooks/useLogoColorVariable';

export const underlineAnimationColorCss = css`
	.underline-animation {
		&:before {
			background: var(--secondary-color);
		}
	}

	.underline-animation-lowercase {
		&:before {
			background: var(--secondary-color);
		}
	}
`;

const StyledWrapper = styled.div`
	${underlineAnimationColorCss};
`;

const Menu = ({ menu: menuData }) => {
	const menu = menuData?.length > 0 ? menuData[0] : null;
	const menuItems = menu?.menuItems || [];
	const firstMenuItem = menuItems[0] || '';
	const contactButtonText = menu?.contactButtonText || '';
	const contactButtonLink = menu?.contactButtonLink || [];

	const finalUnderlineColor = useLogoColorVariable();

	return (
		<StyledWrapper $underlineColor={finalUnderlineColor}>
			<TopRow
				firstMenuItem={firstMenuItem}
				menuItems={menuItems}
				contactButtonText={contactButtonText}
				contactButtonLink={contactButtonLink}
			/>
		</StyledWrapper>
	);
};

export default memo(Menu);
